/* BellvoLux : pop-up « Mystery Gift » en 3 etapes (quiz, e-mail, recompense). JS vanilla. */
if (!customElements.get('bl-popup')) {
  class BlPopup extends HTMLElement {
    connectedCallback() {
      this.key = this.dataset.storageKey || 'bl-popup';
      this.form = this.querySelector('form');
      this.addEventListener('click', (e) => {
        const next = e.target.closest('[data-bl-next]');
        if (next) {
          const note = this.querySelector('[data-bl-answer]');
          if (note) note.value = 'Shopping for: ' + (next.dataset.answer || '');
          this.goTo(2);
          return;
        }
        if (e.target.closest('[data-bl-close]')) this.close();
      });
      this.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') this.close();
      });
      if (this.form) this.form.addEventListener('submit', (e) => this.submit(e));

      const params = new URLSearchParams(location.search);
      if (params.has('bl_popup')) {
        this.open(parseInt(params.get('bl_popup'), 10) || 1);
        return;
      }
      if (window.Shopify && window.Shopify.designMode) return;
      let seen = null;
      try { seen = localStorage.getItem(this.key); } catch (err) {}
      if (seen) return;
      const delay = Math.max(0, parseInt(this.dataset.delay || '8', 10)) * 1000;
      this.timer = setTimeout(() => this.open(1), delay);
    }

    disconnectedCallback() {
      clearTimeout(this.timer);
    }

    goTo(step) {
      this.querySelectorAll('[data-step]').forEach((el) => {
        el.hidden = el.dataset.step !== String(step);
      });
      const input = this.querySelector('[data-step="' + step + '"] input[type="email"]');
      if (input) setTimeout(() => input.focus({ preventScroll: true }), 50);
    }

    open(step) {
      this.goTo(step || 1);
      this.hidden = false;
      document.documentElement.classList.add('bl-popup-open');
      requestAnimationFrame(() => this.classList.add('is-open'));
    }

    close() {
      this.classList.remove('is-open');
      this.hidden = true;
      document.documentElement.classList.remove('bl-popup-open');
      try { localStorage.setItem(this.key, String(Date.now())); } catch (err) {}
    }

    async submit(e) {
      e.preventDefault();
      const err = this.querySelector('[data-bl-error]');
      const btn = this.form.querySelector('[type="submit"]');
      btn.disabled = true;
      try {
        const res = await fetch(this.form.action, {
          method: 'POST',
          body: new FormData(this.form),
          headers: { Accept: 'text/html' },
        });
        if (!res.ok) throw new Error(res.status);
        try { localStorage.setItem(this.key, 'subscribed'); } catch (x) {}
        this.goTo(3);
      } catch (x) {
        if (err) {
          err.textContent = 'Something went wrong, please try again.';
          err.hidden = false;
        }
      } finally {
        btn.disabled = false;
      }
    }
  }
  customElements.define('bl-popup', BlPopup);
}
